/**
 * Apple Sign In Provider — stub, not yet implemented.
 *
 * When implementing:
 * - Load Apple's JS SDK: https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js
 * - Initialize: AppleID.auth.init({ clientId: process.env.VUE_APP_APPLE_CLIENT_ID, redirectURI: '...', scope: 'name email', usePopup: true })
 * - Trigger: const data = await AppleID.auth.signIn()
 * - Send data.authorization.id_token to backend for verification.
 * - Important: name and email are only provided on the first sign-in. Handle missing fields gracefully.
 * - Required env: VUE_APP_APPLE_CLIENT_ID
 */

export async function getToken() {
  throw new Error('Apple sign-in coming soon!');
}
